import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import axios from 'axios';

import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './config/language/i118n';
import { ResponseError } from 'constants/interfaces';
import './config/language/i118n';
import i18n from './config/language/i118n';

// Create browser history to use in the Redux store
const baseUrl = document
    .getElementsByTagName('base')[0]
    .getAttribute('href') as string;
export const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

const router = (
    <React.Suspense fallback={<></>}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    </React.Suspense>
);

//const { dispatch } = store;
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response || 408 === error.response.status) {
            return Promise.reject({
                status: 408,
                title: '',
                message: i18n.t('warnings.connectionError'),
            });
        } else if (400 === error.response.status) {
            return Promise.reject({
                status: 400,
                title: '',
                message: i18n.t('warnings.wrongDataProvided'),
            });
        } else if (401 === error.response.status) {
            history.push(`/auth/login?returnUrl=${window.location.pathname}`);
            return Promise.reject({
                status: 401,
                title: '',
                message: i18n.t('warnings.sessionExpired'),
            });
        } else {
            const message = !!error.response
                ? (error.response.data as ResponseError)
                : (error as ResponseError);
            //dispatch({ type: 'GLOBAL_SET_MESSAGE', payload: message });
            return Promise.reject(message);
        }
    }
);

ReactDOM.render(router, document.getElementById('root'));

registerServiceWorker();
